import type { GetServerSidePropsContext } from "next";

import MenuPage from "@/pages/menu";
import { ORDER_TYPE_ENUM, type OrderType } from "@/constants/enums";
import { fetchMenu } from "@/lib/api";
import { findItemBySlug } from "@/lib/itemSlug";
import { loadBasePageProps } from "@/lib/pageProps";
import type { BasePageProps, MenuItem } from "@/types";

type ItemPageProps = BasePageProps & { seoItem: MenuItem };

export default MenuPage;

const orderTypeFromQuery = (value: unknown): OrderType | undefined => {
  const normalized = String(value ?? "").toLowerCase();
  if (normalized === "delivery") return ORDER_TYPE_ENUM.DELIVERY;
  if (normalized === "take-away" || normalized === "takeaway") return ORDER_TYPE_ENUM.TAKE_AWAY;
  return undefined;
};

export async function getServerSideProps(
  ctx: GetServerSidePropsContext,
): Promise<{ props: ItemPageProps } | { notFound: true }> {
  const base = await loadBasePageProps(ctx);
  const tenantId = base.branch?.tenantId || base.data?.settings?._id;
  if (!tenantId) return { notFound: true };
  const menu = await fetchMenu({
    tenantId,
    orderType: orderTypeFromQuery(ctx.query.order_type),
  });
  const rawSlug = Array.isArray(ctx.query.slug) ? ctx.query.slug[0] : ctx.query.slug;
  const seoItem = findItemBySlug(menu.items ?? [], String(rawSlug ?? ""));
  if (!seoItem) return { notFound: true };
  return { props: { ...base, seoItem } };
}
